import React from "react";
import {
  Settings2,
  Sliders,
  Crosshair,
  ShieldCheck,
  HardHat,
  Award,
} from "lucide-react";

const features = [
  {
    icon: Settings2,
    title: "Multi-Gland Sizing",
    desc: "M20, M25, M32, M40, M50 and M63 — all in a single, integrated tool.",
    spec: "SPEC · 06 SIZES",
  },
  {
    icon: Sliders,
    title: "Adjustable Spacing",
    desc: "Set spacing once. Lock it. Repeat the exact result across the entire panel run.",
    spec: "SPEC · INFINITE STEPS",
  },
  {
    icon: Crosshair,
    title: "Precision Alignment",
    desc: "Engineered to maintain alignment within fractions of a millimetre, every time.",
    spec: "SPEC · ±0.5mm",
  },
  {
    icon: ShieldCheck,
    title: "Durable Construction",
    desc: "Built to survive the bench, the site, the van — and the way real electricians work.",
    spec: "SPEC · TRADE GRADE",
  },
  {
    icon: HardHat,
    title: "Commercial & Industrial",
    desc: "Designed for switchgear manufacturers, panel builders and on-site installations.",
    spec: "SPEC · ALL ENVIRONMENTS",
  },
  {
    icon: Award,
    title: "Patent-Pending Design",
    desc: "A protected innovation purpose-built for SWA cable gland positioning.",
    spec: "SPEC · IP PROTECTED",
  },
];

export const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-grid"
      className="relative py-24 md:py-36 border-t border-[#27272A]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="label-eyebrow">03 / Key Features</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tighter mt-4">
              Engineered for the way{" "}
              <span className="text-[#FF6B00]">the trade actually works.</span>
            </h2>
          </div>
          <div className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-[#A1A1AA] max-w-xs">
            Six core specs — designed and refined with feedback from working
            commercial electricians.
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#27272A] border border-[#27272A]">
          {features.map((f, i) => (
            <div
              key={f.title}
              data-testid={`feature-card-${i + 1}`}
              className="group bg-[#0A0A0A] p-7 md:p-9 hover:bg-[#141414] transition-colors relative"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 grid place-items-center bg-[#1F1F1F] border border-[#27272A] rounded-sm group-hover:border-[#FF6B00] transition-colors">
                  <f.icon
                    className="w-5 h-5 text-[#FF6B00]"
                    strokeWidth={2}
                  />
                </div>
                <span className="font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#A1A1AA]">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-display text-xl md:text-2xl mb-2 tracking-tight">
                {f.title}
              </h3>
              <p className="text-[#A1A1AA] text-sm md:text-[15px] leading-relaxed">
                {f.desc}
              </p>
              <div className="mt-6 pt-4 border-t border-[#27272A] font-mono-spec text-[10px] uppercase tracking-[0.22em] text-[#D4D4D8]">
                {f.spec}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
